import { styled } from '@mui/material'
import damagePin from '../../assets/icons/damagePin.svg'
import { Damage } from '../../constants'

const DamagePinWrapper = styled('span', {
  shouldForwardProp: (prop) =>
    !['xCoordinate', 'yCoordinate', 'zIndexValue'].includes(prop as string),
})<{ xCoordinate: number; yCoordinate: number; zIndexValue?: number }>(
  ({ xCoordinate, yCoordinate, zIndexValue }) => ({
    position: 'absolute',
    top: `${yCoordinate}%`,
    left: `${xCoordinate}%`,
    ...(zIndexValue && { zIndex: zIndexValue }),
  })
)

const DamagePin = styled('img', {
  shouldForwardProp: (prop) =>
    !['highlightingDamage', 'shouldHighlightDamage'].includes(prop as string),
})<{ highlightingDamage?: boolean; shouldHighlightDamage?: boolean }>(
  ({ highlightingDamage, shouldHighlightDamage }) => ({
    display: 'block',
    width: '15px',
    height: '15px',
    marginTop: '-7.8px',
    marginLeft: '-7.5px',
    // Make red pin to gray with filters and highlight only one red pin.
    ...(shouldHighlightDamage &&
      !highlightingDamage && {
        filter:
          'brightness(0) saturate(100%) invert(71%) sepia(1%) saturate(46%) hue-rotate(357deg) brightness(103%) contrast(91%)',
      }),
  })
)

export const DamagePins = ({
  damages = [],
  handleDamagePinClick,
  highlightedDamage = null,
}: {
  damages: Damage[]
  handleDamagePinClick?: (damage: Damage) => void
  highlightedDamage?: Damage | null
}) => {
  return damages.map((damage) => (
    <DamagePinWrapper
      xCoordinate={damage.xCoordinate}
      yCoordinate={damage.yCoordinate}
      key={
        damage.id + damage.timestamp + damage.xCoordinate + damage.yCoordinate
      }
      {...(highlightedDamage && {
        zIndexValue: damage.timestamp === highlightedDamage.timestamp ? 5 : 1,
      })}
    >
      <DamagePin
        src={damagePin}
        alt="DamagePin"
        {...(handleDamagePinClick && {
          onClick: () => handleDamagePinClick(damage),
        })}
        {...(highlightedDamage && {
          highlightingDamage: damage.timestamp === highlightedDamage.timestamp,
          shouldHighlightDamage: true,
        })}
      />
    </DamagePinWrapper>
  ))
}
